import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import CollectOrderService from "../../../services/CollectOrderService";
import MinorCollectOrderDetails from "../../molecules/MinorCollectOrderDetails";
import CamposColetor, { coletorDoForm } from "../../molecules/CamposColetor";

// Notifica a portaria de uma coleta que já saiu em rota sem alerta.
//
// Existe porque a notificação na expedição é opcional: quem expediu sem saber
// quem ia retirar pode informar depois, e o alerta sai com a mesma Guia de
// Expedição em anexo. Sem isso, a saída ficaria sem registro para sempre.

export default function NotifyCollectorModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    async function fetchCollectOrder() {
      const cOrder = await CollectOrderService.getCollectOrdersById(collectOrderId);
      setCollectOrderObject(cOrder);
    }

    fetchCollectOrder();
  }, [collectOrderId, isModalOpen]);

  const jaNotificada = Boolean(collectOrderObject?.collectOrder?.coletor?.nome);

  const onSubmit = async (form) => {
    setEnviando(true);
    try {
      await CollectOrderService.notificarColetor(collectOrderId, coletorDoForm(form));
      toast.success("Portaria notificada!");
      setModalOpen(!isModalOpen);
      reset();
    } catch (error) {
      // Mantém o modal aberto para corrigir sem redigitar tudo.
      toast.error(error.message);
    } finally {
      setEnviando(false);
    }
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto" onClick={onClose}>
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div
              className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>

              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  NOTIFICAR PORTARIA
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta: {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest
                      ? collectOrderObject?.collectOrder.idRequest
                      : "AVULSO"}
                  </div>
                </div>
              </div>

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* MODAL FORM BEGIN */}
              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm gap-4">

                    <div className="text-[11px] text-gray-600 bg-gray-100 rounded-md px-3 py-2">
                      Identifique quem saiu com a coleta. A portaria vai receber
                      um e-mail com estes dados e a Guia de Expedição anexada.
                    </div>

                    {/* O botão na lista só aparece para coletas sem coletor, mas
                        a tela atualiza por polling: se outra pessoa notificou
                        enquanto este modal estava aberto, avisa antes de mandar
                        uma 2ª via para a portaria sem necessidade. */}
                    {jaNotificada && (
                      <div className="text-[11px] bg-amber-100 text-amber-900 rounded-md px-3 py-2">
                        <strong>Esta coleta já foi notificada</strong> (coletor:{" "}
                        {collectOrderObject?.collectOrder?.coletor?.nome}). Enviar
                        de novo marca o e-mail como <strong>2ª via</strong>.
                      </div>
                    )}

                    <CamposColetor register={register} errors={errors} />

                    <div className="flex gap-4">
                      <button
                        disabled={enviando}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-sky-700 text-white py-2 px-4 rounded-md hover:bg-sky-800 disabled:bg-gray-400 disabled:cursor-not-allowed"
                      >
                        {enviando ? "Notificando..." : "Notificar Portaria"}
                      </button>

                      <button
                        onClick={onClose}
                        className="w-full bg-neutral-500 text-white py-2 px-4 rounded-md hover:bg-neutral-600"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
